import { User } from '@/lib/types/user';
import { KeyClubProfile } from '@/lib/types/keyClubProfile';
import { prefixStateCode } from '@/lib/functions/prefixStateCode';

// Fills missing User fields with KC profile data; KC data is lower priority than Sylius profile data.
export function mergeUserWithKcProfile(user: User | undefined, kcProfile: KeyClubProfile | null): User | undefined {
  if (!user) return undefined;
  if (!kcProfile) return user;

  return {
    ...user,
    firstName: user.firstName || kcProfile.first_name || null,
    lastName: user.lastName || kcProfile.last_name || null,
    email: user.email || kcProfile.primary_email || null,
    phoneNumber: user.phoneNumber || kcProfile.primary_phone || null,
    billingAddress: {
      ...user.billingAddress,
      firstName: user.billingAddress?.firstName || kcProfile.first_name,
      lastName: user.billingAddress?.lastName || kcProfile.last_name,
      phoneNumber: user.billingAddress?.phoneNumber || kcProfile.primary_phone,
      email: user.billingAddress?.email || kcProfile.primary_email,
      street: user.billingAddress?.street || kcProfile.address_1 || '',
      street2: user.billingAddress?.street2 || kcProfile.address_2,
      city: user.billingAddress?.city || kcProfile.city || '',
      postcode: user.billingAddress?.postcode || kcProfile.zip || '',
      provinceCode: user.billingAddress?.provinceCode || prefixStateCode(kcProfile.state || 'TX'),
    },
    shippingAddress: {
      ...user.shippingAddress,
      firstName: user.shippingAddress?.firstName || kcProfile.first_name,
      lastName: user.shippingAddress?.lastName || kcProfile.last_name,
      phoneNumber: user.shippingAddress?.phoneNumber || kcProfile.primary_phone,
      street: user.shippingAddress?.street || kcProfile.address_1 || '',
      street2: user.shippingAddress?.street2 || kcProfile.address_2,
      city: user.shippingAddress?.city || kcProfile.city || '',
      postcode: user.shippingAddress?.postcode || kcProfile.zip || '',
      provinceCode: user.shippingAddress?.provinceCode || prefixStateCode(kcProfile.state || 'TX'),
    },
  };
}
